import type { IconType } from "./Icon"

const iconTypeClassNames = {
  thin: "fa-thin",
  light: "fa-light",
  regular: "fa-regular",
  solid: "fa-solid",
  brand: "fa-brands",
  duotone: "fa-duotone",
}
export const getIconTypeClassName = (type: IconType) => iconTypeClassNames[type]
